/* Accommodations */
export const ACCOMMODATIONS_COMPARATOR_ADD_COMPARATOR = 'ACCOMMODATIONS_COMPARATOR_ADD_COMPARATOR'
export const ACCOMMODATIONS_COMPARATOR_REMOVE_COMPARATOR = 'ACCOMMODATIONS_COMPARATOR_REMOVE_COMPARATOR'

export const ACCOMMODATIONS_COMPARATOR_SET_REGION = 'ACCOMMODATIONS_COMPARATOR_SET_REGION'
export const ACCOMMODATIONS_COMPARATOR_SET_DATA_TYPE = 'ACCOMMODATIONS_COMPARATOR_SET_DATA_TYPE'

export const ACCOMMODATIONS_DATA = 'ACCOMMODATIONS_DATA'
export const ACCOMMODATIONS_DATA_SUCCESS = 'ACCOMMODATIONS_DATA_SUCCESS'
export const ACCOMMODATIONS_DATA_ERROR = 'ACCOMMODATIONS_DATA_ERROR'

/* Guests Satisfaction */
export const GUESTS_SATISFACTION_COMPARATOR_ADD_COMPARATOR = 'GUESTS_SATISFACTION_COMPARATOR_ADD_COMPARATOR'
export const GUESTS_SATISFACTION_COMPARATOR_REMOVE_COMPARATOR = 'GUESTS_SATISFACTION_COMPARATOR_REMOVE_COMPARATOR'

export const GUESTS_SATISFACTION_COMPARATOR_SET_REGION = 'GUESTS_SATISFACTION_COMPARATOR_SET_REGION'
export const GUESTS_SATISFACTION_COMPARATOR_SET_DATA_TYPE = 'GUESTS_SATISFACTION_COMPARATOR_SET_DATA_TYPE'

export const GUESTS_SATISFACTION_DATA = 'GUESTS_SATISFACTION_DATA'
export const GUESTS_SATISFACTION_DATA_SUCCESS = 'GUESTS_SATISFACTION_DATA_SUCCESS'
export const GUESTS_SATISFACTION_DATA_ERROR = 'GUESTS_SATISFACTION_DATA_ERROR'

/* Tourist Source */
export const TOURIST_SOURCE_COMPARATOR_ADD_COMPARATOR = 'TOURIST_SOURCE_COMPARATOR_ADD_COMPARATOR'
export const TOURIST_SOURCE_COMPARATOR_REMOVE_COMPARATOR = 'TOURIST_SOURCE_COMPARATOR_REMOVE_COMPARATOR'

export const TOURIST_SOURCE_COMPARATOR_SET_REGION = 'TOURIST_SOURCE_COMPARATOR_SET_REGION'
export const TOURIST_SOURCE_COMPARATOR_SET_DATA_TYPE = 'TOURIST_SOURCE_COMPARATOR_SET_DATA_TYPE'
export const TOURIST_SOURCE_COMPARATOR_SET_SOURCE = 'TOURIST_SOURCE_COMPARATOR_SET_SOURCE'

export const TOURIST_SOURCE_DATA = 'TOURIST_SOURCE_DATA'
export const TOURIST_SOURCE_DATA_SUCCESS = 'TOURIST_SOURCE_DATA_SUCCESS'
export const TOURIST_SOURCE_DATA_ERROR = 'TOURIST_SOURCE_DATA_ERROR'

/* Map Visualizers */
export const ACCOMMODATIONS_MAP_VISUALIZERS_SET_SHOWN_STATE = 'ACCOMMODATIONS_MAP_VISUALIZERS_SET_SHOWN_STATE'
export const GUESTS_SATISFACTION_MAP_VISUALIZERS_SET_SHOWN_STATE = 'GUESTS_SATISFACTION_MAP_VISUALIZERS_SET_SHOWN_STATE'
export const TOURIST_SOURCE_MAP_VISUALIZERS_SET_SHOWN_STATE = 'TOURIST_SOURCE_MAP_VISUALIZERS_SET_SHOWN_STATE'

/* Map and Data States */
export const ACCOMMODATIONS_SET_CURRENT_SELECTION = 'ACCOMMODATIONS_SET_CURRENT_SELECTION'
export const GUESTS_SATISFACTION_SET_CURRENT_SELECTION = 'GUESTS_SATISFACTION_SET_CURRENT_SELECTION'
export const TOURIST_SOURCE_SET_CURRENT_SELECTION = 'TOURIST_SOURCE_SET_CURRENT_SELECTION'


// WEBPACK FOOTER //
// ./src/actions/actionTypes.js